import { useState } from "react";
import { useLocation, Link } from "react-router-dom";
import { useScrolled } from "../hooks.jsx";
import { Ic } from "../icons.jsx";
import { PAGES_NAV, LABEL } from "../data.js";
import logoHeader from "../../assets/logo-header.png";

const ROUTE = {
  funzionalita:    "/funzionalita",
  "come-funziona": "/come-funziona",
  prezzi:          "/prezzi",
  tutorial:        "/tutorial",
  faq:             "/faq",
  contatti:        "/contatti",
  cerca:           "/cerca",
};

export default function Navbar() {
  const sc = useScrolled();
  const { pathname } = useLocation();
  const [mob, setMob] = useState(false);

  const isActive = (p) => {
    const route = ROUTE[p] ?? `/${p}`;
    if (p === 'cerca') return ['/cerca', '/noleggio-auto', '/noleggio-moto'].includes(pathname);
    return pathname === route;
  };

  return (
    <>
      <nav className={`nav${sc ? " sc" : ""}`}>
        <div className="nav-in">
          {/* Logo */}
          <Link to="/" className="nav-logo" style={{ textDecoration: "none" }}>
            <img src={logoHeader} alt="NoleggioinCloud" style={{ height: 32, width: "auto", objectFit: "contain" }} />
          </Link>

          {/* Desktop links */}
          <ul className="nav-links">
            {PAGES_NAV.map(p => (
              <li key={p}>
                <Link
                  to={ROUTE[p] ?? `/${p}`}
                  className={isActive(p) ? "act" : ""}
                  style={{ textDecoration: "none" }}
                >
                  {LABEL[p]}
                </Link>
              </li>
            ))}
          </ul>

          {/* CTA + Hamburger — "Accedi" porta a /login, "Inizia gratis" porta a /register */}
          <div className="nav-r">
            <Link to="/login"    className="btn btn-o btn-sm" style={{ textDecoration: "none" }}>Accedi</Link>
            <Link to="/register" className="btn btn-p btn-sm" style={{ textDecoration: "none" }}>Inizia gratis</Link>
            {/* Hamburger */}
            <button className="hb" onClick={() => setMob(v => !v)} aria-label="Apri menu">
              <span /><span /><span />
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile overlay */}
      <div className={`mob${mob ? " open" : ""}`}>
        <div className="mob-head">
          <img src={logoHeader} alt="NoleggioinCloud" style={{ height: 26, width: "auto", objectFit: "contain" }} />
          <button
            onClick={() => setMob(false)}
            style={{ background: "none", border: "none", cursor: "pointer", color: "var(--muted)" }}
          >
            <Ic n="close" s={22} />
          </button>
        </div>
        <div className="mob-links">
          {PAGES_NAV.map(p => (
            <Link
              key={p}
              to={ROUTE[p] ?? `/${p}`}
              onClick={() => setMob(false)}
              style={{ textDecoration: "none" }}
            >
              {LABEL[p]}
            </Link>
          ))}
        </div>
        <div className="mob-cta">
          <Link
            to="/login"
            className="btn btn-o btn-lg"
            style={{ justifyContent: "center", textDecoration: "none" }}
            onClick={() => setMob(false)}
          >
            Accedi
          </Link>
          <Link
            to="/register"
            className="btn btn-p btn-lg"
            style={{ justifyContent: "center", textDecoration: "none" }}
            onClick={() => setMob(false)}
          >
            Inizia gratis — 14 giorni →
          </Link>
        </div>
      </div>
    </>
  );
}
